import {isNativeWebView} from '../isNativeWebView';
import {AndroidDeviceDependencies as Dependencies} from '../types';

function voidFn(): void {}

export function onlyNative<T>(fn: T, di: Dependencies = {}): T {
  const isNative = isNativeWebView(di);
  return isNative ? fn : (voidFn as any as T);
}
